import apiService from './apiService';

export const assetService = {
    assetRequirements: {
        getAll: () => apiService.get('/asset-requirements'),
        getById: (id) => apiService.get(`/asset-requirements/${id}`),
        getByCompany: (companyId) => apiService.get(`/asset-requirements/company/${companyId}`),
        getByCompanyAndActive: (companyId, active = true) =>
            apiService.get(`/asset-requirements/company/${companyId}/active`, { active }),
        getByCompanyAndClientType: (companyId, clientType) =>
            apiService.get(`/asset-requirements/company/${companyId}/client-type/${clientType}`),
        getMandatoryByCompanyAndClientType: (companyId, clientType) =>
            apiService.get(`/asset-requirements/company/${companyId}/client-type/${clientType}/mandatory`),
        create: (data) => apiService.post('/asset-requirements', data),
        update: (id, data) => apiService.put(`/asset-requirements/${id}`, data),
        toggleStatus: (id) => apiService.patch(`/asset-requirements/${id}/toggle-status`),
        delete: (id) => apiService.delete(`/asset-requirements/${id}`)
    },

    clientAssets: {
        submit: (data) => apiService.post('/client-assets/submit', data),
        getById: (id) => apiService.get(`/client-assets/${id}`),
        getByAssetCode: (code) => apiService.get(`/client-assets/code/${code}`),
        getByClient: (clientId) => apiService.get(`/client-assets/client/${clientId}`),
        getByClientPaginated: (clientId, page = 0, size = 20) =>
            apiService.get(`/client-assets/client/${clientId}/paginated`, { page, size }),
        getByClientAndCompany: (clientId, companyId) =>
            apiService.get(`/client-assets/client/${clientId}/company/${companyId}`),
        getByStatus: (status) => apiService.get(`/client-assets/status/${status}`),
        getByStatusPaginated: (status, page = 0, size = 20) =>
            apiService.get(`/client-assets/status/${status}/paginated`, { page, size }),
        getPending: () => apiService.get('/client-assets/pending'),
        search: (query) => apiService.get('/client-assets/search', { query }),
        searchPaginated: (query, page = 0, size = 20) =>
            apiService.get('/client-assets/search/paginated', { query, page, size }),
        checkComplete: (clientId, companyId) =>
            apiService.get(`/client-assets/client/${clientId}/company/${companyId}/complete`),
        update: (id, data) => apiService.put(`/client-assets/${id}`, data),
        verify: (id) => apiService.patch(`/client-assets/${id}/verify`),
        reject: (id, reason) => apiService.patch(`/client-assets/${id}/reject`, { reason }),
        activate: (id) => apiService.patch(`/client-assets/${id}/activate`),
        deactivate: (id) => apiService.patch(`/client-assets/${id}/deactivate`),
        delete: (id) => apiService.delete(`/client-assets/${id}`),
        getStatistics: () => apiService.get('/client-assets/statistics')
    },

    vehicleData: {
        getMakes: () => apiService.get('/vehicle-data/makes'),
        getModels: (makeId) => apiService.get(`/vehicle-data/makes/${makeId}/models`),
        createMake: (name) => apiService.post('/vehicle-data/makes', { name }),
        updateMake: (id, name) => apiService.put(`/vehicle-data/makes/${id}`, { name }),
        toggleMake: (id) => apiService.patch(`/vehicle-data/makes/${id}/toggle`),
        deleteMake: (id) => apiService.delete(`/vehicle-data/makes/${id}`),
        createModel: (makeId, name) => apiService.post(`/vehicle-data/makes/${makeId}/models`, { name }),
        updateModel: (id, name) => apiService.put(`/vehicle-data/models/${id}`, { name }),
        toggleModel: (id) => apiService.patch(`/vehicle-data/models/${id}/toggle`),
        deleteModel: (id) => apiService.delete(`/vehicle-data/models/${id}`)
    },

    assetDocuments: {
        upload: (data) => apiService.post('/asset-documents', data),
        uploadWithFile: async (assetId, file, documentType, description, isPrimary = false) => {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('clientAssetId', assetId);
            if (documentType) formData.append('documentType', documentType);
            if (description) formData.append('description', description);
            formData.append('isPrimary', String(isPrimary));

            const token = localStorage.getItem('nexus_token');
            const response = await fetch(
                `${apiService.baseURL}/asset-documents/upload`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': token ? `Bearer ${token}` : ''
                    },
                    body: formData
                }
            );

            return await apiService.handleResponse(response);
        },
        getByAsset: (assetId) => apiService.get(`/asset-documents/asset/${assetId}`),
        getById: (id) => apiService.get(`/asset-documents/${id}`),
        setPrimary: (id) => apiService.patch(`/asset-documents/${id}/set-primary`),
        delete: (id) => apiService.delete(`/asset-documents/${id}`)
    }
};
